import { useEffect, useState, FC } from "react";
// Libraries
import { isEqual } from "lodash";
// API
import { GetAnimalsList_animalsExtended_animals } from "api/MyLivestock/Animal/types/GetAnimalsList";
import { GetGroupQuery } from "generated/graphql";
// Utils
import { TABLE_IDS } from "constants/Interface";
import { usePrevious } from "hooks";
// Components
import { AnimalsTable } from "components/MyLivestock";
import { NoItemsFound, Flex, Spacer } from "components";
// Resources
import styles from "./AnimalsInGroup.module.scss";

export interface AnimalsInGroupProps {
  group: GetGroupQuery["group"];
  isEdited: boolean;
  searchedAnimals?: (GetAnimalsList_animalsExtended_animals | null)[];
}

const AnimalsInGroup: FC<AnimalsInGroupProps> = ({ group, isEdited, searchedAnimals = [] }) => {
  const previousSearchedAnimals = usePrevious(searchedAnimals);
  const [groupTableAnimals, setGroupTableAnimals] = useState(searchedAnimals);
  useEffect(() => {
    if (!isEqual(previousSearchedAnimals, searchedAnimals)) {
      setGroupTableAnimals(searchedAnimals);
    }
  }, [previousSearchedAnimals, searchedAnimals]);

  if (groupTableAnimals && groupTableAnimals.length === 0) {
    return (
      <>
        <Spacer baselineHeight={1} />

        <NoItemsFound title={isEdited ? "No available livestock" : "No animals found in the group"} />

        <Spacer baselineHeight={2} />
      </>
    );
  }

  return (
    <Flex className={styles.prevent_tiny_table} container item itemGrow>
      <Flex item itemGutter xs={12}>
        <AnimalsTable
          // @ts-ignores
          animals={groupTableAnimals}
          // @ts-ignores
          fromPage={!isEdited ? "group" : null}
          // @ts-ignores
          group={group}
          isShowActionButtons={!isEdited}
          showCheckboxes={isEdited}
          tableId={TABLE_IDS.GROUP_ANIMALS}
        />
      </Flex>
    </Flex>
  );
};
AnimalsInGroup.displayName = "AnimalsInGroup";

export default AnimalsInGroup;
